<p-card
  [header]="product.name"
  class="product"
  styleClass="product mb-4"
  id="product-{{ product.productId }}"
  [attr.data-name]="product.name"
  [attr.data-price]="product.price">
  <ng-template pTemplate="header" styleClass="heyhey">
    <img alt="Card" [src]="product.image_url" />
  </ng-template>
  <!-- <div class="p-card-subheader">
    {{ product.price }}
  </div> -->
  <p>{{ product.description }}</p>
  <ng-template pTemplate="footer">
    <div class="flex gap-3 mt-1">
      <!-- <p-button
      label="Cancel"z
      severity="secondary"
      class="w-full"
      styleClass="w-full"
    /> -->
      <!-- <p-button
        (click)="addToCart()"
        label="Añadir a carrito"
        class="w-full"
        styleClass="w-full cart-add"
      /> -->
      <p-button
        (click)="
          product.productType === 1
            ? selectProductIngredients()
            : addToCart(product)
        "
        [label]="product.productType === 1 ? 'Añadir' : 'Añadir a carrito'"
        class="w-full"
        styleClass="w-full cart-add" />
    </div>
  </ng-template>
</p-card>
